import {get as _get, cloneDeep as _cloneDeep} from 'lodash';
import initialState from '../../initialstate';
import * as types from '../../../actions/actiontypes';
import normalizeOrgChart from './normalizeOrgChart';
import rootEntityId from '../../../util/uiconstants';
import {HttpStatusCodes} from '../../../util/uiconstants';

export default function orgChartReducer(state = initialState.orgChart, action) {
	switch (action.type) {
		case types.UPDATE_ENTITY: {
			if (
				action?.responseObj?.status === HttpStatusCodes.Ok &&
				action?.meta?.api?.data?.stepUpdated === 99 &&
				action?.meta?.entity
			) {
				const updatedEntity = action?.meta?.entity;
				const orgChart = [...state];

				const updatedOrgchart = orgChart?.map((node) => {
					if (node.entityId === updatedEntity.entityId) {
						const newNode = {...node};

						newNode.label = updatedEntity.entityName;
						return newNode;
					}

					return node;
				});

				return updatedOrgchart;
			}

			return state;
		}
		case types.GET_ORG_CHART: {
			if (!_.isEmpty(action.response)) {
				return normalizeOrgChart(
					action.payload,
					!action.payload.isRiskAssessmentPage ? action.response : updateAccessibility(action.response)
				);
			}
			return state;
		}
		case types.SET_ORG_CHART: {
			if (!_.isEmpty(action.orgChart)) {
				return _.cloneDeep(action.orgChart);
			}
			return state;
		}
		default:
			return state;
	}
}

const updateAccessibility = (entities) => {
	const findEntityById = (entities, id) => entities.find((entity) => entity.id === id);

	const updateParentAccessibility = (entity, entities) => {
		if (entity.parentEntityId && entity.parentEntityId !== rootEntityId) {
			const parentEntity = findEntityById(entities, entity.parentEntityId);
			if (parentEntity && !parentEntity.isAccessible) {
				parentEntity.isAccessible = true;
			}
		}
	};

	const updateChildrenAccessibility = (entityId, entities) => {
		entities
			.filter((child) => child.parentEntityId === entityId)
			.forEach((child) => {
				if (!child.isAccessible) {
					child.isAccessible = true;
				}
			});
	};

	// Iterate through each entity and update parent accessibility if needed
	entities.forEach((entity) => {
		if (entity.isAccessible) {
			updateParentAccessibility(entity, entities);
			//children to be updated
			updateChildrenAccessibility(entity.id, entities);
		}
	});

	return entities;
};
